export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');
export const getIdToken = () => localStorage.getItem('idToken');

export const setAccessToken = accessToken => localStorage.setItem('accessToken', accessToken);
export const setRefreshToken = refreshToken => localStorage.setItem('refreshToken', refreshToken);
export const setIdToken = idToken => localStorage.setItem('idToken', idToken);
